import React from 'react'
import classnames from 'classnames'
import * as styles from './index.module.less'

interface StructureImageProps {
  className?: string;
  src?: string;
  alt?: string;
  width?: number;
}
const StructureImage: React.FC<StructureImageProps> = props => {
  const {
    className,
    src,
    alt,
    width
  } = props;
  return (
    <div className={classnames(styles.StructureImage, className)}>
      <img src={src} alt={alt} style={{width: width}} />
    </div>
  );
}

export default StructureImage;